import { DatePipe } from "@angular/common";
import { Component, OnInit, OnDestroy } from "@angular/core";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import { LmsService } from "../_Lms/services/lms.service";
import { DataSharingService } from "../AuthGuard/DataSharingService";
import { MasterService } from "../Shared/app.Masters.Service";
import { SnackbarComponent } from "../snackbar/snackbar.component";
declare var $;

@Component({
    selector: "app-emi-calculator",
    templateUrl: "./emi-calculator.component.html",
    styleUrls: ["./emi-calculator.component.scss"],
    standalone: false
})
export class EmiCalculatorComponent implements OnInit, OnDestroy {
  currentUser: any;
  currentDate: any;
  CompanyName: any;
  stepEmiForm: boolean = false;
  showSpinner: boolean = false;
  Name: any = "Months";
  loading: boolean = false;
  cEIModel: any = {
    Asset_Cost: 0,
    IRR_Type: "Flat",
    EMI_Type: "Monthly",
    ProductId: "",
    IRR_CalculateBy: "ROI",
    Adv_Inst: 0,
    DueDate: new Date(),
  };
  effectiveIrrData: any = 0.00;
  stepEMI: any[] = [];
  AmortizationColumns: string[] = [];
  emiIrr: any;
  AmortizationSource: any;
  stepEmiData: any;
  isFrequency: boolean = false;
  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };
  selectedScheme: any = {};
  FrequenctDropDownList: any;
  IRR_CalculateByDropDownList: any;
  constructor(
    private _MasterService: MasterService,
    private snackBar: MatSnackBar,
    private LmsService: LmsService,
    private datePipe: DatePipe,
    private dataSharingService: DataSharingService
  ) { }

  ngOnInit() {
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    // this.CompanyName = this.currentUser.CompanyName;
    // console.log("currentUser", this.currentUser.CompanyName);
    this.cEIModel = {};
    this.GetFrequenctDropDown();
    this.GetIRR_CalculateByDropDown();
    this.AmortizationSource = null;
    // this.stepEMI = [];
    this.cEIModel.IRR_CalculateBy = "FLAT_EMI";
    this.cEIModel.EMI_Type = "Monthly";
    this.stepEmiForm = false;
    this.cEIModel.Adv_Inst = 0;
  }
  GetIRR_CalculateByDropDown() {
    this._MasterService
      .GetCommonMaster_FOR_DROPDOWN({ Type: "IRR_CalculateBy" })
      .subscribe((res: any) => {
        console.log(res);
        this.IRR_CalculateByDropDownList = res;

      });

  }
  GetFrequenctDropDown() {
    this._MasterService
      .GetCommonMaster_FOR_DROPDOWN({ Type: "EMI FREQUENCY" })
      .subscribe((res: any) => {
        console.log(res);
        this.FrequenctDropDownList = res;
      });
  }
  ngOnDestroy() {
    const modalElement = document.getElementById("EMICalculator");
    if (modalElement && modalElement.parentElement === document.body) {
      document.body.removeChild(modalElement);
    }
  }
  onCloseEMICalculator() {
    $("#EMICalculator").modal("hide");
  }
  openModal() {
    const modalElement = document.getElementById("EMICalculator");
    if (modalElement && modalElement.parentElement !== document.body) {
      document.body.appendChild(modalElement);
    }
    $("#EMICalculator").modal("show");
    this.cEIModel = {};
    this.AmortizationSource = null;
    //  this.stepEMI = [];
    this.cEIModel.IRR_CalculateBy = "FLAT_EMI";
    this.cEIModel.EMI_Type = "Monthly";
    this.cEIModel.Adv_Inst = 0;

    this.stepEmiForm = false;
    this.emiIrr = null;
  }

  onCalculateEmiAndIRR() {
    console.log("cEIModel", this.cEIModel);
    let netAmount: any[] = [];
    let roi: any[] = [];

    if (+this.cEIModel.NetFinance_Amt <= 0) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Net Finance Amount should be greater than 0.",
        ...this.configSuccess,
      });
      return;
    }
    if (
      +this.cEIModel.Flat_Rate < 0 &&
      this.cEIModel.IRR_CalculateBy == "ROI"
    ) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Flat rate should be greater than 0.",
        ...this.configSuccess,
      });
      return;
    }
    if (
      +this.cEIModel.EMI_Amount <= 0 &&
      this.cEIModel.IRR_CalculateBy == "FLAT_EMI"
    ) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "EMI amount should be greater than 0.",
        ...this.configSuccess,
      });
      return;
    }
    if (+this.cEIModel.No_Of_Inst <= 0) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "No of Installment should be greater than 0.",
        ...this.configSuccess,
      });
      return;
    }
    if (+this.cEIModel.Tenure <= 0) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Tenure should be greater than 0.",
        ...this.configSuccess,
      });
      return;
    }
    if (
      this.cEIModel.IRR_CalculateBy == "FLAT_EMI" &&
      +this.cEIModel.EMI_Amount * +this.cEIModel.No_Of_Inst <
      +this.cEIModel.NetFinance_Amt
    ) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "No of Installment multiply by EMI amount should be greater than or equal to Net Finance Amount.",
        ...this.configSuccess,
      });
      return;
    }
    if (this.selectedScheme.Amount) {
      netAmount = this.selectedScheme.Amount.split("-");
      roi = this.selectedScheme.ROI.split("-");
      if (
        +this.cEIModel.NetFinance_Amt > +netAmount[1] ||
        +this.cEIModel.NetFinance_Amt < +netAmount[0]
      ) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "Net Finance Amount should be in between Scheme Amount.",
          ...this.configSuccess,
        });
        return;
      }
      if (
        this.cEIModel.IRR_CalculateBy == "ROI" &&
        (+this.cEIModel.Flat_Rate > +roi[1] ||
          +this.cEIModel.Flat_Rate < +roi[0])
      ) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "Flate Rate should be in between Scheme ROI.",
          ...this.configSuccess,
        });
        return;
      }
      if (
        +(this.cEIModel.EMI_Type == "Monthly" ? this.cEIModel.Adv_Inst : 0) <
        +this.selectedScheme.AdvanceEMI
      ) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "Advance Installment can not be less than Scheme Advance EMI.",
          ...this.configSuccess,
        });
        return;
      }
      this.calculateEmiIrr();
    } else {
      this.calculateEmiIrr();
    }
  }

  calculateEmiIrr() {
    this.stepEmiForm = true;
    let stepArr: any[] = [];
    if (this.cEIModel.IRR_CalculateBy == "STEP_EMI") {
      this.cEIModel.IsStep = true;
      if (this.stepEMI.length < 1) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "Please add step EMI first",
          ...this.configSuccess,
        });
        return;
      }
      let lastEMI = this.stepEMI[this.stepEMI.length - 1].ToEMI;
      if (+lastEMI != +this.cEIModel.No_Of_Inst) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "Total EMI Should Be Equal To No of Installment",
          ...this.configSuccess,
        });
        return;
      }
      if (
        this.stepEmiData != undefined &&
        +this.stepEmiData.totalAmount < +this.cEIModel.NetFinance_Amt
      ) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "Total EMI Amount should be  equal or Greater then  Net Finance Amount.",
          ...this.configSuccess,
        });
        return;
      }
      for (let i = 0; i < this.stepEMI.length; i++) {
        for (
          let j = +this.stepEMI[i].FromEMI;
          j <= +this.stepEMI[i].ToEMI;
          j++
        ) {
          if (+this.stepEMI[i].EMI_Amount >= 0) {
            stepArr.push(this.stepEMI[i].EMI_Amount);
          }
        }
      }
    } else {
      this.cEIModel.IsStep = false;
      this.cEIModel.STEP_IRR = 0;
    }
    let _data = { ...this.cEIModel };
    _data.cashflow = stepArr;
    if (this.cEIModel.IsStep) {
      _data.EMI_Amount = this.stepEmiData.totalAmount;
    }

    this.getCalculateEMIIRR(_data);
  }

  getCalculateEMIIRR(data: any) {
    this.stepEmiForm = true;
    this.showSpinner = true;
    // data.ProductId = 2;
    data.DaysInYear = this.currentUser.DaysInYear;
    this.LmsService.GetEMICalculate(data).subscribe((res: any) => {
      this.showSpinner = false;
      this.emiIrr = res[0];
      setTimeout(() => {
        var elmntToView = document.getElementById("scrollto");
        elmntToView.scrollIntoView();
      }, 500);

      if (this.cEIModel.IRR_CalculateBy == "ROI") {
        this.stepEMI = [];

        this.stepEMI.push({
          FromEMI: 1,
          ToEMI: this.cEIModel.No_Of_Inst,
          EMI_Amount: this.emiIrr.EMI_Amt.toFixed(2),
          NoOfInstl: this.cEIModel.No_Of_Inst,
          TotalAmount: this.emiIrr.Agreement_Value.toFixed(2),
          disable: true,
        });
        var amt = this.emiIrr.EMI_Amt.toFixed(2);
        $(function () {
          $("#EMI_Amounts").val(amt);
        });
      }
      if (this.cEIModel.IRR_CalculateBy == "Reducing_ROI") {
        this.stepEMI = [];

        this.stepEMI.push({
          FromEMI: 1,
          ToEMI: this.cEIModel.No_Of_Inst,
          EMI_Amount: this.emiIrr.EMI_Amt.toFixed(2),
          NoOfInstl: this.cEIModel.No_Of_Inst,
          TotalAmount: this.emiIrr.Agreement_Value.toFixed(2),
          disable: true,
        });
        var amt = this.emiIrr.EMI_Amt.toFixed(2);
        $(function () {
          $("#EMI_Amounts").val(amt);
        });
      }
      if (this.cEIModel.IRR_CalculateBy == "FLAT_EMI") {
        this.stepEMI = [];

        this.stepEMI.push({
          FromEMI: 1,
          ToEMI: this.cEIModel.No_Of_Inst,
          EMI_Amount: this.emiIrr.EMI_Amt.toFixed(2),
          NoOfInstl: this.cEIModel.No_Of_Inst,
          TotalAmount: this.emiIrr.Agreement_Value.toFixed(2),
          disable: true,
        });
        var amt = this.emiIrr.ROI.toFixed(2);
        $(function () {
          $("#Flat_Rate").val(amt);
        });
      }

      var ReqModel = {};
      if (
        this.stepEMI.length > 0 &&
        this.cEIModel.IRR_CalculateBy == "STEP_EMI"
      ) {
        let _stepEmi: any[] = [];
        this.stepEMI.forEach((obj: any) => {
          _stepEmi.push(this.dataSharingService.cleanObject({ ...obj }));
        });
        ReqModel = {
          LoanAmount: this.cEIModel.NetFinance_Amt,
          Disbursement_Amt: this.emiIrr.Disbursement_Amt,
          LoanPeriod: this.cEIModel.No_Of_Inst,
          Application_EMIType: this.cEIModel.EMI_Type,
          NoOfEMI: this.cEIModel.Tenure,
          NoOfEMI_Adv:
            this.cEIModel.EMI_Type == "Monthly" ? this.cEIModel.Adv_Inst : 0,
          DisbIRR: this.emiIrr.Case_IRR,
          DueDate: this.cEIModel.DueDate,
          LoanDate: this.cEIModel.Loan_Date,
          IRR_CalculateBy: this.cEIModel.IRR_CalculateBy,
          DaysInYear: this.currentUser.DaysInYear,
          JSON: JSON.stringify({ StepIRR: _stepEmi }),
        };
        this._MasterService
          .LMS_EMI_Calculator_With_StepEmi(ReqModel)
          .subscribe((resAmor: any) => {
            console.log("resAmor", resAmor);
            this.effectiveIrrData = resAmor[0].effectiveIrrData;
            this.AmortizationColumns = [
              "PERIOD",
              "DueDate",
              "EMI_Amount",
              "PRINCIPAL",
              "INTEREST",
              "Principle_OS",
            ];
            this.AmortizationSource = new MatTableDataSource(resAmor);
          });
      } else {
        ReqModel = {
          LoanAmount: this.cEIModel.NetFinance_Amt,
          Disbursement_Amt: this.emiIrr.Disbursement_Amt,
          LoanPeriod: this.cEIModel.No_Of_Inst,
          Application_EMIType: this.cEIModel.EMI_Type,
          EMIAmount: this.emiIrr.EMI_Amt,
          RateOfInterest: this.emiIrr.ROI,
          NoOfEMI: this.cEIModel.No_Of_Inst,
          AdvanceInst:
            this.cEIModel.EMI_Type == "Monthly" ? this.cEIModel.Adv_Inst : 0,
          DisbIRR: this.emiIrr.Disbursement_IRR,
          InterestAmount: this.emiIrr.Interest_Amt,
          DueDate: this.cEIModel.DueDate,
          LoanDate: this.cEIModel.Loan_Date,
          IRR_CalculateBy: this.cEIModel.IRR_CalculateBy,
          DaysInYear: this.currentUser.DaysInYear,
        };
        this._MasterService
          .LMS_EMI_Calculator_Without_StepEmi(ReqModel)
          .subscribe((resAmor: any) => {
            console.log("resAmor", resAmor);
            this.effectiveIrrData = resAmor[0].effectiveIrrData;
            this.AmortizationColumns = [
              "PERIOD",
              "DueDate",
              "EMI_Amount",
              "PRINCIPAL",
              "INTEREST",
              "Principle_OS",
            ];
            this.AmortizationSource = new MatTableDataSource(resAmor);
          });
      }
    });
  }

  handleByChange(event: any) {
    //   this.emiIrr = undefined;
    //   if (this.cEIModel.IRR_CalculateBy == 'ROI') {
    //       delete this.cEIModel.EMI_Amount;
    //   }
    //   else {
    //       delete this.cEIModel.Flat_Rate;
    //   }
    this.emiIrr = undefined;
    if (this.cEIModel.IRR_CalculateBy == "ROI") {
      delete this.cEIModel.EMI_Amount;
    } else {
      delete this.cEIModel.Flat_Rate;
    }
    if (this.cEIModel.IRR_CalculateBy !== "STEP_EMI") {
      this.stepEMI = [];
    } else {
      this.stepEMI.push({
        FromEMI: 1,
        ToEMI: "",
        EMI_Amount: "",
        disable: false,
      });
      this.stepEmiData = undefined;
    }
    //this.stepEmiForm = false;
  }
  setTenure() {
    if (this.cEIModel.No_Of_Inst) {
      if (this.cEIModel.EMI_Type == "ByMonthly") {
        this.cEIModel.Tenure = 2 * +this.cEIModel.No_Of_Inst;
      } else if (this.cEIModel.EMI_Type == "Quarterly") {
        this.cEIModel.Tenure = 3 * +this.cEIModel.No_Of_Inst;
      } else if (this.cEIModel.EMI_Type == "HalfYearly") {
        this.cEIModel.Tenure = 6 * +this.cEIModel.No_Of_Inst;
      } else if (this.cEIModel.EMI_Type == "Yearly") {
        this.cEIModel.Tenure = 12 * +this.cEIModel.No_Of_Inst;
      } else if (this.cEIModel.EMI_Type == "Weekly") {
        this.cEIModel.Tenure = 7 * +this.cEIModel.No_Of_Inst;
      } else if (this.cEIModel.EMI_Type == "Fortnightly") {
        this.cEIModel.Tenure = 15 * +this.cEIModel.No_Of_Inst;
      } else if (this.cEIModel.EMI_Type == "ByWeekly") {
        this.cEIModel.Tenure = 14 * +this.cEIModel.No_Of_Inst;
      } else if (this.cEIModel.EMI_Type == "FourthWeekly") {
        this.cEIModel.Tenure = 28 * +this.cEIModel.No_Of_Inst;
      } else {
        this.cEIModel.Tenure = this.cEIModel.No_Of_Inst;
      }

      if (
        this.cEIModel.EMI_Type == "Daily" ||
        this.cEIModel.EMI_Type == "Weekly" ||
        this.cEIModel.EMI_Type == "Fortnightly" ||
        this.cEIModel.EMI_Type == "ByWeekly" ||
        this.cEIModel.EMI_Type == "FourthWeekly"
      )
        this.Name = "Days";
      else this.Name = "Months";
    } else {
      this.cEIModel.Tenure = "";
    }
    var diffMonth =
      (this.cEIModel.DueDate.getFullYear() -
        this.cEIModel.Loan_Date.getFullYear()) *
      12 +
      (this.cEIModel.DueDate.getMonth() - this.cEIModel.Loan_Date.getMonth());

    if (this.cEIModel.EMI_Type == "ByMonthly") {
      this.cEIModel.Tenure = this.cEIModel.Tenure - (2 - diffMonth);
    } else if (this.cEIModel.EMI_Type == "Quarterly") {
      this.cEIModel.Tenure = this.cEIModel.Tenure - (3 - diffMonth);
    } else if (this.cEIModel.EMI_Type == "HalfYearly") {
      this.cEIModel.Tenure = this.cEIModel.Tenure - (6 - diffMonth);
    } else if (this.cEIModel.EMI_Type == "Yearly") {
      this.cEIModel.Tenure = this.cEIModel.Tenure - (12 - diffMonth);
    }

    this.setAdvanceInstl();
  }
  handleChange(event: any) {
    this.emiIrr = undefined;
    if (this.cEIModel.IRR_Type == "Flat") {
      this.stepEMI = [];
    } else {
      this.stepEMI.push({
        FromEMI: 1,
        ToEMI: "",
        EMI_Amount: "",
        disable: false,
      });
      this.stepEmiData = undefined;
    }
  }
  setAdvanceInstl() {
    if (Number(this.cEIModel.Adv_Inst) >= Number(this.cEIModel.No_Of_Inst)) {
      this.cEIModel.Adv_Inst = 0;
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Advance Installment not greater than No. Of Installment !!!",
        ...this.configSuccess,
      });
    }
  }
  setType(event: any) {
    if (this.cEIModel.IRR_CalculateBy == "STEP_EMI") {
      this.stepEmiForm = true;
      this.cEIModel.EMI_Type = "Monthly";
      this.cEIModel.Tenure = this.cEIModel.No_Of_Inst;
    }
    if (this.cEIModel.IRR_CalculateBy == "Reducing_ROI")
      this.isFrequency = true;
    else this.isFrequency = false;
    //if (this.cEIModel.Type == 'EMIAmt')
    //  this.cEIModel.IRR_CalculateBy = 'FLAT_EMI'
    //if (this.cEIModel.Type == 'StepEMI')
    //  this.cEIModel.IRR_CalculateBy = 'STEP_EMI'

    this.emiIrr = undefined;
    if (this.cEIModel.IRR_CalculateBy == "ROI") {
      delete this.cEIModel.EMI_Amount;
    } else {
      delete this.cEIModel.Flat_Rate;
    }

    if (this.cEIModel.IRR_CalculateBy !== "STEP_EMI") {
      this.stepEMI = [];
    } else {
      this.stepEMI.push({
        FromEMI: 1,
        ToEMI: "",
        EMI_Amount: "",
        disable: false,
      });
      this.stepEmiData = undefined;
    }
  }
  addNextStep(data: any) {
    if (+data.ToEMI <= 0 || +data.EMI_Amount < 0) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Please Fill All Data.",
        ...this.configSuccess,
      });
      return;
    } else if (+data.ToEMI > +this.cEIModel.No_Of_Inst) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "To Emi can not be greater than number of installment.",
        ...this.configSuccess,
      });
      return;
    }
    // if (+data.ToEMI == +this.cEIModel.No_Of_Inst) {
    //     this.snackBar.openFromComponent(SnackbarComponent, { data: "Another Step can not be added. You can add till number of installment.", ...this.configSuccess });
    //     return;
    // }
    else {
      if (+data.FromEMI > +data.ToEMI) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "To EMI should be greater than From EMI.",
          ...this.configSuccess,
        });
        return;
      }
      data.NoOfInstl = +data.ToEMI - +data.FromEMI + 1;
      data.TotalAmount = data.NoOfInstl * +data.EMI_Amount;
      if (+data.ToEMI < +this.cEIModel.No_Of_Inst) {
        data.disable = true;
        this.stepEMI.push({
          FromEMI: +data.ToEMI + 1,
          ToEMI: "",
          EMI_Amount: "",
          disable: false,
        });
      }
      this.getTotlaEmiAndAmount();
    }
  }
  getTotlaEmiAndAmount() {
    if (this.stepEMI.length > 1) {
      let TotalEmi: any = 0,
        TotalAmount: any = 0;
      for (let i = 0; i < this.stepEMI.length; i++) {
        if (this.stepEMI[i].EMI_Amount) {
          TotalEmi =
            TotalEmi + (+this.stepEMI[i].ToEMI - +this.stepEMI[i].FromEMI + 1);
          TotalAmount =
            TotalAmount +
            (+this.stepEMI[i].ToEMI - +this.stepEMI[i].FromEMI + 1) *
            +this.stepEMI[i].EMI_Amount;
        }
      }
      this.stepEmiData = { totalEmi: TotalEmi, totalAmount: TotalAmount };
    }
  }
  removeLastStep(index: any) {
    this.stepEMI.splice(index, 1);
    this.stepEMI[index - 1].disable = false;
    this.getTotlaEmiAndAmount();
  }
  totaltypewise(type) {
    if (
      this.AmortizationSource &&
      this.AmortizationSource != null &&
      this.AmortizationSource != ""
    ) {
      let sum = 0;
      for (let i = 0; i < this.AmortizationSource.filteredData.length; i++) {
        sum += Number(this.AmortizationSource.filteredData[i][type]);
      }
      return sum > 0 ? sum.toFixed(2) : "";
    }
    return 0;
  }
  exportTable(exporter: any) {
    exporter.exportTable("xls", {
      fileName: `Amortization`,
      sheet: "Amortization",
    });
  }
  // printToPDF() {
  //   this.currentDate = new Date();

  //   setTimeout(() => {
  //     const printContent = document.getElementById("printSection");
  //     const WindowObject = window.open(
  //       "",
  //       "PrintWindow",
  //       "width=800,height=600,top=50,left=50,toolbars=no,scrollbars=yes,status=no,resizable=yes"
  //     );

  //     WindowObject.document.writeln(`
  //     <!DOCTYPE html>
  //     <html>
  //       <head>
  //         <title>EMI Calculator Report - FINNAUX TECHSOLUTIONS</title>
  //         <style>
  //           ${this.getPrintStyles()}
  //         </style>
  //       </head>
  //       <body>
  //         ${printContent.innerHTML}
  //       </body>
  //     </html>
  //   `);

  //     WindowObject.document.close();
  //     WindowObject.focus();

  //     setTimeout(() => {
  //       WindowObject.print();
  //       WindowObject.close();
  //     }, 500);
  //   }, 100);
  // }

  // getPrintStyles() {
  //   return `
  //   body {
  //     font-family: Arial, sans-serif;
  //     margin: 0;
  //     padding: 0;
  //     background: white;
  //     color: black;
  //     font-size: 12px;
  //     line-height: 1.4;
  //   }

  //   .print-header {
  //     border-bottom: 2px solid #333;
  //     padding-bottom: 10px;
  //     margin-bottom: 20px;
  //     text-align: center;
  //   }

  //   .print-header h1 {
  //     font-size: 24px;
  //     margin: 0 0 10px 0;
  //     color: #2c3e50;
  //   }

  //   .company-info {
  //     font-size: 11px;
  //     color: #666;
  //   }

  //   .print-content {
  //     padding: 0 10px;
  //   }

  //   .section {
  //     margin-bottom: 25px;
  //     page-break-inside: avoid;
  //   }

  //   .section h2 {
  //     font-size: 16px;
  //     background-color: #f8f9fa;
  //     padding: 8px 12px;
  //     margin: 0 0 12px 0;
  //     border-left: 4px solid #2c3e50;
  //     color: #2c3e50;
  //   }

  //   .input-grid, .results-grid {
  //     display: grid;
  //     grid-template-columns: 1fr 1fr;
  //     gap: 8px;
  //     margin-bottom: 15px;
  //   }

  //   .input-row, .result-row {
  //     display: flex;
  //     justify-content: space-between;
  //     padding: 6px 0;
  //     border-bottom: 1px dotted #ddd;
  //   }

  //   .input-label, .result-label {
  //     font-weight: bold;
  //     color: #555;
  //   }

  //   .input-value, .result-value {
  //     color: #333;
  //   }

  //   .table-container {
  //     max-height: 400px;
  //     overflow-y: auto;
  //     border: 1px solid #ddd;
  //   }

  //   .amortization-table, .step-emi-table {
  //     width: 100%;
  //     border-collapse: collapse;
  //     font-size: 10px;
  //   }

  //   .amortization-table th, .step-emi-table th {
  //     background-color: #2c3e50;
  //     color: white;
  //     padding: 8px 6px;
  //     text-align: left;
  //     font-weight: bold;
  //     position: sticky;
  //     top: 0;
  //   }

  //   .amortization-table td, .step-emi-table td {
  //     padding: 6px;
  //     border-bottom: 1px solid #ddd;
  //     text-align: left;
  //   }

  //   .amortization-table tbody tr:nth-child(even), .step-emi-table tbody tr:nth-child(even) {
  //     background-color: #f8f9fa;
  //   }

  //   .amortization-table tfoot, .step-emi-table tfoot {
  //     background-color: #e9ecef;
  //     font-weight: bold;
  //   }

  //   .amortization-table tfoot td, .step-emi-table tfoot td {
  //     padding: 8px 6px;
  //     border-top: 2px solid #2c3e50;
  //   }

  //   .print-footer {
  //     border-top: 1px solid #333;
  //     padding-top: 10px;
  //     margin-top: 30px;
  //     text-align: center;
  //     font-size: 10px;
  //     color: #666;
  //   }

  //   button {
  //     display: none !important;
  //   }

  //   @page {
  //     margin: 1cm;
  //   }
  // `;
  // }

  getCalculationTypeName(type: string): string {
    const types = {
      ROI: "Flat ROI",
      FLAT_EMI: "Flat EMI",
      STEP_EMI: "Step EMI",
      Reducing_ROI: "Reducing ROI",
    };
    return types[type] || type;
  }

  getFrequencyName(frequency: string): string {
    const frequencies = {
      Daily: "Daily",
      Weekly: "Weekly",
      Fortnightly: "Fortnightly",
      ByWeekly: "Two-Weekly",
      FourthWeekly: "Four-Weekly",
      Monthly: "Monthly",
      ByMonthly: "Bi-Monthly",
      Quarterly: "Quarterly",
      HalfYearly: "Half Yearly",
      Yearly: "Yearly",
    };
    return frequencies[frequency] || frequency;
  }
  getAmortizationDataForPrint() {
    if (this.AmortizationSource && this.AmortizationSource.data) {
      return this.AmortizationSource.data;
    }
    return [];
  }

  formatDateForPrint(date: any): string {
    if (!date) return "";

    if (typeof date === "string") {
      return date;
    }

    if (date instanceof Date) {
      return this.datePipe.transform(date, "dd/MM/yyyy") || "";
    }

    return date.toString();
  }

  formatNumber(value: any): string {
    if (value === null || value === undefined) return "0";

    const num = typeof value === "string" ? parseFloat(value) : value;

    if (isNaN(num)) return "0";

    if (Number.isInteger(num)) {
      return num.toString();
    }

    return num.toFixed(2);
  }

  // Update the printToPDF method to handle large tables
  printToPDF() {
    this.currentDate = new Date();

    setTimeout(() => {
      const printContent = document.getElementById("printSection");
      const WindowObject = window.open(
        "",
        "PrintWindow",
        "width=1000,height=700,top=50,left=50,toolbars=no,scrollbars=yes,status=no,resizable=yes"
      );

      const styles = this.getPrintStyles();

      WindowObject.document.writeln(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>EMI Calculator Report - FINNAUX TECHSOLUTIONS</title>
          <style>
            ${styles}
          </style>
        </head>
        <body onload="window.print(); window.close();">
          ${printContent.innerHTML}
        </body>
      </html>
    `);

      WindowObject.document.close();
    }, 100);
  }

  getPrintStyles() {
    return `
    body { 
      font-family: Arial, sans-serif; 
      margin: 0; 
      padding: 15px; 
      background: white; 
      color: black;
      font-size: 12px;
      line-height: 1.4;
    }
    
    .print-header {
      border-bottom: 2px solid #333;
      padding-bottom: 10px;
      margin-bottom: 20px;
      text-align: center;
    }
    
    .print-header h1 {
      font-size: 24px;
      margin: 0 0 10px 0;
      color: #2c3e50;
    }
    
    .company-info {
      font-size: 11px;
      color: #666;
    }
    
    .print-content {
      padding: 0;
    }
    
    .section {
      margin-bottom: 25px;
      page-break-inside: avoid;
    }
    
    .section h2 {
      font-size: 16px;
      background-color: #f8f9fa;
      padding: 8px 12px;
      margin: 0 0 12px 0;
      border-left: 4px solid #2c3e50;
      color: #2c3e50;
    }
    
    .input-grid, .results-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 8px;
      margin-bottom: 15px;
    }
    
    .input-row, .result-row {
      display: flex;
      justify-content: space-between;
      padding: 6px 0;
      border-bottom: 1px dotted #ddd;
    }
    
    .input-label, .result-label {
      font-weight: bold;
      color: #555;
    }
    
    .input-value, .result-value {
      color: #333;
    }
    
    .table-container {
      border: 1px solid #ddd;
      page-break-inside: avoid;
    }
    
    .amortization-table, .step-emi-table {
      width: 100%;
      border-collapse: collapse;
      font-size: 9px;
      page-break-inside: auto;
    }
    
    .amortization-table th, .step-emi-table th {
      background-color: #2c3e50;
      color: white;
      padding: 6px 4px;
      text-align: left;
      font-weight: bold;
    }
    
    .amortization-table td, .step-emi-table td {
      padding: 4px 3px;
      border-bottom: 1px solid #ddd;
      text-align: left;
      page-break-inside: avoid;
    }
    
    .amortization-table tbody tr:nth-child(even), .step-emi-table tbody tr:nth-child(even) {
      background-color: #f8f9fa;
    }
    
    .amortization-table tfoot, .step-emi-table tfoot {
      background-color: #e9ecef;
      font-weight: bold;
    }
    
    .amortization-table tfoot td, .step-emi-table tfoot td {
      padding: 6px 4px;
      border-top: 2px solid #2c3e50;
    }
    
    .print-footer {
      border-top: 1px solid #333;
      padding-top: 10px;
      margin-top: 30px;
      text-align: center;
      font-size: 10px;
      color: #666;
    }
    
    button {
      display: none !important;
    }
    
    @media print {
      @page {
        margin: 0.5cm;
        size: A4 landscape;
      }
      
      body {
        padding: 10px;
      }
      
      .section {
        page-break-inside: avoid;
      }
      
      .amortization-table {
        font-size: 8px;
      }
      
      .amortization-table th,
      .amortization-table td {
        padding: 3px 2px;
      }
      
      tr {
        page-break-inside: avoid;
      }
    }
  `;
  }
  //DueDateChange() {
  //  var diffMonth = (this.cEIModel.DueDate.getFullYear() - this.cEIModel.Loan_Date.getFullYear()) * 12 + (this.cEIModel.DueDate.getMonth() - this.cEIModel.Loan_Date.getMonth())
  //  this.cEIModel.Tenure = this.cEIModel.Tenure - (6-diffMonth)+1
  //}
}
